import { useState, useEffect } from "react";

const ENTER = ["Enter"];
const ESCAPE = ["Escape"];
const ENTER_OR_SPACE = ["Enter", " "];
const TAB = "Tab";

export const keyboardInteractions = {
    link: ENTER,
    escapeKey: ESCAPE,
    button: ENTER_OR_SPACE,
    menuItem: ENTER_OR_SPACE
};

/**
 * This is a generic function to any dev that want to use it related to keyboardEvents
 * The function receives and object that primarily contains:
 * @param {event} event - Event parameter
 * @param {Array} keys - a list  string values of keys to listen
 * @param {function} output - what the code will do (fires a funciont) after the key is pressed
 */
export const handleKeyboardDownEvent = ({ event, keys, output }) => {
    // Prevent browsers from scrolling down when interacting with SPACE bar (activate a button for example)
    if (event.key === " ") {
        event.preventDefault();
    }
    if (keys.includes(event.key)) {
        output();
    }
};

/**
 * helper to make the navigation with tab and shif + tab
 * @param {event} event - the default event from the listener
 * @param {function} nextAction - an action to be perfomed to move the focus to the next element
 * @param {function} prevAction - an action to be perfomed to move the focus to the previous element
 */
export const keyboardTabNavigation = ({ event, nextAction = () => {}, prevAction = () => {} }) => {
    if (event.shiftKey && event.key === TAB) {
        prevAction();
    } else if (event.key === TAB) {
        nextAction();
    }
};

/*
Query that can be used to find an actionnable element under a given HTML node
for example 
  using React useRef(): referencedNode.current.querySelector(firstActionableElementQuery)
  in an AngularJS directive: 
  var DummyDirective = function ($injector, $timeout) {
    return {
        ...
        link: function (scope, element, attrs) {
          ...
          const firstActionnableElement = element[0].querySelector(firstActionableElementQuery);
          firstActionnableElement && firstActionnableElement.focus();
          ...
        }
    };
 */

export const queryFocusableElements =
    '[tabindex="0"], a:not([tabindex="-1"]), button:not([tabindex="-1"]), input:not([tabindex="-1"]), textarea:not([tabindex="-1"]), select:not([tabindex="-1"]), details:not([tabindex="-1"])';

/* 
This is a custom hook that helps getting updated about the document.activeElement which is the HTML element that is currently havig the focus on 
*/
export function useActiveElement(elementId) {
    const [active, setActive] = useState(document.activeElement);

    const handleFocusIn = () => {
        setActive(document.activeElement);
    };

    const element = document.querySelector(elementId);

    useEffect(() => {
        if (element) {
            element.addEventListener("focusin", handleFocusIn);
            return () => {
                element.removeEventListener("focusin", handleFocusIn);
            };
        }
    }, [element]);
    return active;
}

/* 
This is a generic function that helps to extract a group id from a HTML tag id containing a group id and a suffix
The function receives an ID like "accountID-anySuffix" and will return "accountID"
The suffix must start by "-" character 
The account ID is made of 2 parts separated by "-"
examples: 
extractGroupId("897654-01-submenu") === "897654-01"
extractGroupId("1234-04-submenu") === "1234-04"

Taxable accounts is made of 3 partes separated by "-" with format of group id-individual id
This extract will keep the individual id since it will be the unique identiefer for instances with multiple accounts, same group id
extractGroupId("897654-01-2345678-submenu") === "897654-01-2345678"

 */

export const extractGroupId = (HTMLElementId) => {
    const getPosition = (mainstring, substring, pos) => {
        let len = pos;
        if (mainstring.split(substring).length > 3) {
            len = 3;
        }
        return mainstring.split(substring, len).join(substring).length;
    };
    return HTMLElementId.substring(0, getPosition(HTMLElementId, "-", 2));
};

export const setAriaLabelledByToElement = (elementClassname, idToAssociate) => {
    const e = document.getElementsByClassName(elementClassname).item(0);
    if (e) {
        e.setAttribute("aria-labelledby", idToAssociate);
    }
};
